/** Tema oscuro cálido — alineado con SongLibrary / StudioLayout. */
export const GYM_STUDIO = {
  bg: "#1c1a19",
  bgElevated: "#242220",
  bgCard: "#2a2826",
  bgCardHover: "#32302e",
  border: "rgba(232, 224, 212, 0.08)",
  borderHover: "rgba(232, 224, 212, 0.15)",
  textMain: "#f5f0eb",
  textMuted: "#a09890",
  textDim: "#6a635c",
  accent: "#ec4899",
  accentGlow: "rgba(236, 72, 153, 0.22)",
  accentSoft: "rgba(236, 72, 153, 0.1)",
} as const;
